import { render, staticRenderFns } from "./RegularBillingNew.vue?vue&type=template&id=1272b714&"
import script from "./RegularBillingNew.vue?vue&type=script&lang=js&"
export * from "./RegularBillingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports